import { Outlet, Link, useLocation } from 'react-router-dom'
import { BriefcaseBusiness, CheckCircle2 } from 'lucide-react'
import { AUTH_LOGIN_BG, AUTH_REGISTER_BG } from '@/data/assets'
import { usePlatformSettings } from '@/hooks/usePlatformSettings'

const LOGIN_STATS = [
  { value: '12,000+', label: '在线岗位' },
  { value: '3,000+', label: '入驻企业' },
  { value: '96.5%', label: '就业率' },
]

const REGISTER_FEATURES = [
  '海量优质岗位，精准匹配你的需求',
  '校企合作直通，实习就业一步到位',
  '专业求职指导，助力职业快速成长',
]

export default function AuthLayout() {
  const { pathname } = useLocation()
  const { platformName, platformLogo, platformDescription } = usePlatformSettings()
  const isRegister = pathname.includes('register')
  const bgImage = isRegister ? AUTH_REGISTER_BG : AUTH_LOGIN_BG

  return (
    <div className="min-h-screen flex">
      {/* 品牌侧 */}
      <div className="hidden lg:flex relative w-[560px] overflow-hidden flex-col justify-between p-14">
        {/* 背景图 */}
        <img
          src={bgImage}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* 渐变遮罩 */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A]/95 via-[#3662EC]/90 to-[#5B82F5]/85" />
        {/* 装饰光晕 */}
        <div className="absolute -left-[100px] -top-[120px] w-[320px] h-[320px] rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.25)_0%,transparent_100%)]" />
        <div className="absolute left-[200px] -top-[60px] w-[420px] h-[420px] rounded-full bg-[radial-gradient(circle,rgba(165,200,255,0.35)_0%,transparent_100%)]" />

        {/* Logo */}
        <Link to="/" className="relative flex min-w-0 items-center gap-2.5">
          <div className="w-10 h-10 rounded-[10px] bg-white/20 backdrop-blur-sm flex items-center justify-center overflow-hidden">
            {platformLogo ? (
              <img src={platformLogo} alt={`${platformName} logo`} className="h-full w-full bg-white object-contain p-1" />
            ) : (
              <BriefcaseBusiness className="w-5 h-5 text-white" />
            )}
          </div>
          <span className="whitespace-nowrap text-[clamp(15px,1.8vw,20px)] font-bold text-white">{platformName}</span>
        </Link>

        {/* Slogan */}
        <div className="relative space-y-4">
          <h2 className="text-white text-[32px] font-bold leading-[1.4] max-w-[420px]">
            {isRegister ? '开启你的职业生涯' : '连接校企，赋能就业'}
          </h2>
          <p className="text-white/80 text-[15px] leading-relaxed max-w-[420px]">
            {isRegister
              ? '加入平台，获取海量优质岗位与实习机会，让求职更简单高效。'
              : platformDescription || '跨区域职业院校培训就业服务平台，为求职者与企业搭建高效对接桥梁。'}
          </p>
        </div>

        {/* Bottom: Stats or Features */}
        <div className="relative">
          {isRegister ? (
            <div className="space-y-3.5">
              {REGISTER_FEATURES.map((feat) => (
                <div key={feat} className="flex items-center gap-2.5">
                  <CheckCircle2 className="w-[18px] h-[18px] text-white/80 shrink-0" />
                  <span className="text-white/80 text-sm">{feat}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex gap-9">
              {LOGIN_STATS.map((s) => (
                <div key={s.label} className="flex flex-col gap-1">
                  <span className="text-white text-2xl font-bold">{s.value}</span>
                  <span className="text-white/60 text-[13px]">{s.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* 表单侧 */}
      <div className="flex-1 bg-white flex flex-col items-center justify-center p-8 lg:p-14">
        <div className="w-full max-w-[400px]">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
